__turbopack_context__.v({
  "htmlRenderer": "RenderHtml-module-scss-module__6OwQlG__htmlRenderer",
});
